<!--
 * @Author: 陈绍斌 1748362428@qq.com
 * @Date: 2023-06-02 10:55:54
 * @LastEditors: pliybird
 * @LastEditTime: 2023-07-20 17:29:35
 * @FilePath: \Vyung.Portal.Front\src\views\IndustrySolution\components\retail\RetailFMCGAdvantage.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
 * @Description: 零售快消行业：方案优势
-->
<template>
  <div class="retail_advantage rn-section-gap">
    <section>
      <div class="container">
        <SectionTitle
          :title="$t('solution.advantages_title')"
          description="ADVANTAGES"
          textAlign="center"
        />
        <div class="retail_content">
          <div
            class="advantage_content"
            :class="{ advantage_content_en: $i18n.locale !== 'zh_CN' }"
          >
            <div
              v-for="(item, index) in list"
              :key="index"
              class="advantage_card advantage_position position"
            >
              <div class="advantage_position f_title">{{ item.title }}</div>
              <div
                v-if="index < list.length - 1"
                class="advantage_position s_title"
              >
                {{ item.desc }}
              </div>
              <div v-else class="advantage_position s_title">
                <ol>
                  <li v-for="(ite, index) in item.desc" :key="index">
                    {{ ite.title }}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SectionTitle from '@/components/elements/sectionTitle/SectionTitle'
export default {
  name: 'RetailFMCGAdvantage',
  components: { SectionTitle },
  props: {

  },
  data () {
    return {
      list: [
        { title: this.$t('solution.retail.advantages.tab.tab01'), desc: this.$t('solution.retail.advantages.tab.desc01') },
        { title: this.$t('solution.retail.advantages.tab.tab02'), desc: this.$t('solution.retail.advantages.tab.desc02') },
        { title: this.$t('solution.retail.advantages.tab.tab03'), desc: this.$t('solution.retail.advantages.tab.desc03') },
        {
          title: this.$t('solution.retail.advantages.tab.tab04'), desc: [
            { title: this.$t('solution.retail.advantages.tab.desc04.title1') },
            { title: this.$t('solution.retail.advantages.tab.desc04.title2') },
            { title: this.$t('solution.retail.advantages.tab.desc04.title3') },
            { title: this.$t('solution.retail.advantages.tab.desc04.title4') }
          ]
        },
      ]
    }
  },
  methods: {

  }
}
</script>